module.exports = __webpack_public_path__ + "img/ear-deaf.103c27a2.svg";